import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
export default class RankingImage extends Component {
  view() {
    const imgUrl = app.forum.attribute("fof-gamification.topimage".concat(this.attrs.place, "Url"));
    const place = this.attrs.place;
    return imgUrl ? m("img", {
      className: "rankings-mobile rankings-image rankings-".concat(place),
      src: imgUrl,
      alt: ""
    }) : m("td", {
      className: "rankings-mobile rankings-".concat(place)
    }, m(Icon, {
      name: "fas fa-trophy"
    }));
  }
}
flarum.reg.add('fof-gamification', 'forum/components/RankingImage', RankingImage);